import { render } from "./RegFormCustom.vue?vue&type=template&id=0db505bc&scoped=true"
import script from "./RegFormCustom.vue?vue&type=script&lang=js"
export * from "./RegFormCustom.vue?vue&type=script&lang=js"

import "./RegFormCustom.vue?vue&type=style&index=0&id=0db505bc&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db505bc"]])

export default __exports__